export enum Role {
  Admin = "admin",
  User = "user",
  Distributor = "distributor",
  Manager = "manager",
  Master = "master",
  Marketing = "marketing",
  Operator = "operator",
  Installer = "installer",
  SuperAdmin = "superadmin",
}
